import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
// components
import { LoadingScreen } from 'src/components/loading-screen';
import CompactLayout from 'src/layouts/compact';

// ----------------------------------------------------------------------
const AppDownloadPage = lazy(() => import('src/pages/app-download'));

// ----------------------------------------------------------------------

export const volunteersRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <CompactLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </CompactLayout>
      </AuthGuard>
    ),
    children: [{ path: 'app-download', element: <AppDownloadPage />, index: true }],
  },
];
